import React from 'react';
import notfound from './404.jpg'

export default function NotFound() {

  return (
      <div>
          <img src={notfound} alt="Not Found"/>
      </div>
  );
}
